import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="18"
    height="23"
    viewBox="0 0 18 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4996 10.5329C17.4996 15.8979 13.7876 20.9149 8.79961 22.1329C3.81161 20.9149 0.0996094 15.8979 0.0996094 10.5329V4.73288L8.79961 0.866211L17.4996 4.73288V10.5329ZM8.79961 20.1995C12.4246 19.2329 15.5663 14.9215 15.5663 10.7455V5.98954L8.79961 2.97354L2.03294 5.98954V10.7455C2.03294 14.9215 5.17461 19.2329 8.79961 20.1995ZM11.7479 15.3662L8.77061 13.5779L5.80294 15.3662L6.58594 11.9829L3.96628 9.72088L7.42694 9.42121L8.77061 6.23121L10.1239 9.41154L13.5846 9.71121L10.9553 11.9829L11.7479 15.3662Z"
      fill="#222A5C"
    />
  </svg>,
  "Bundle"
);
